export enum reportTypes {
    REPORT_DATA = 'REPORT_DATA'
}